module.exports = __webpack_public_path__ + "media/images/regions/causal_graphs/north_america-6c93e16e9346f7a37603345bd2c9f320.svg";